import React from 'react';
import { scrollToOffer } from '../utils/scroll';
export const GuaranteeSection: React.FC = () => {
  return <section className="py-20" data-id="element-76">
      <div className="container mx-auto px-4 max-w-2xl" data-id="element-77">
        <div className="text-center rounded-xl p-10 border" style={{
        background: 'var(--bg-card)',
        borderColor: 'var(--border-gold)'
      }} data-id="element-78">
          <div className="text-5xl mb-4" data-id="element-79">🛡️</div>
          <h2 className="font-serif text-3xl font-bold mb-4" data-id="element-80">
            Garantía de Satisfacción Total
          </h2>
          <p className="text-base leading-relaxed mb-6" style={{
          color: 'var(--text-secondary)'
        }} data-id="element-81">
            Comprá con total tranquilidad. Tenés{' '}
            <strong data-id="element-82">7 días de garantía</strong>: si descargás el material y
            sentís que no te sirve, pedís el reembolso completo. Sin preguntas,
            sin vueltas. El riesgo es cero.
          </p>
          <button onClick={scrollToOffer} className="font-bold text-lg px-10 py-4 rounded-md uppercase tracking-widest transition-all duration-300 hover:-translate-y-0.5" style={{
          background: 'linear-gradient(135deg, var(--gold), var(--gold-dark))',
          color: 'var(--bg-dark)',
          boxShadow: '0 4px 20px rgba(200,163,78,0.3)'
        }} data-id="element-83">
            COMPRAR SIN RIESGO
          </button>
        </div>
      </div>
    </section>;
};